import NewOrganizationAurora from "../aurora/NewOrganization/NewOrganizationAurora";
import NewOrganizationClassic from "../classic/NewOrganization/NewOrganizationClassic";

// Define el tipo del componente Login
interface NewOrganizationComponent {
  Classic: typeof NewOrganizationClassic;
  Aurora: typeof NewOrganizationAurora;
}

// Crear el contenedor lógico
const NewOrganization: NewOrganizationComponent = {
  Classic: NewOrganizationClassic,
  Aurora: NewOrganizationAurora,
};

export default NewOrganization;
